export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export interface IFileSizeValidator {
  isFileSizeValid(file: any, maxSize: number): boolean;
}
